import React from "react";
import { connect } from "react-redux";

import { account } from "shared/storeInfo";
import GlobalError from "./GlobalError";
import GlobalSpinner from "./GlobalSpinner";

// This component manages our fetch* error and spinner flow
// and top-level authorization
const mapStateToProps = (state, ownProps) => {
  return {
    fetchErrorCode: state.app.fetchErrorCode,
    fetchErrorMessages: state.app.fetchErrorMessages,
    isFetching: state.app.isFetching,
    requiredAuth: ownProps.requiredAuth,
  };
};

const mapDispatchToProps = () => {
  return {};
};

const isAuthorized = requiredAuth => {
  if (!requiredAuth) {
    return true;
  }

  if (!account("type")) {
    return false;
  }

  if (requiredAuth.type !== account("type")) {
    return false;
  }

  if (
    requiredAuth.pricingTier &&
    !requiredAuth.pricingTier.includes(account("pricingTier"))
  ) {
    return false;
  }

  return true;
};

const component = props => (
  <Choose>
    <When condition={!isAuthorized(props.requiredAuth)}>
      <GlobalError messages={["Seitenaufruf nicht gestattet"]} />
    </When>
    <When
      condition={
        props.fetchErrorCode ||
        (props.fetchErrorMessages && props.fetchErrorMessages.length > 0)
      }
    >
      <GlobalError
        code={props.fetchErrorCode}
        messages={props.fetchErrorMessages}
      />
    </When>
    <When condition={props.isFetching}>
      <GlobalSpinner />
    </When>
    <Otherwise>{props.children}</Otherwise>
  </Choose>
);

const GlobalContainer = connect(mapStateToProps, mapDispatchToProps)(component);

export default GlobalContainer;
